import React, { ReactNode, useEffect, useMemo } from "react";
import { styled, t, useTheme } from "@superset-ui/core";
import { Popover, Checkbox, Button } from "antd";

import ControlHeader from "src/explore/components/ControlHeader";

import PopoverContent from "./PopoverContent";

type ValidationError = string;
export interface CustomSortControlProps {
    onChange: (params: string[] | undefined) => void;
    value?: string[];
    actions: any;
    name?: string;
    label?: ReactNode;
    description?: ReactNode;
    validationErrors?: ValidationError[];
    renderTrigger?: boolean;
    warning?: string;
    danger?: string;
    hovered?: boolean;
    onClick?: () => void;
    tooltipOnClick?: () => void;
    rightNode?: ReactNode;
    leftNode?: ReactNode;
    viz_type?: string;
    active: boolean;
    useActive?: boolean;
}

const CustomSortControl = (props: CustomSortControlProps) => {
    const { actions, active, useActive, value = [], viz_type } = props;

    const { colors, gridUnit } = useTheme();

    const [saveList, setSaveList] = React.useState<string[]>([]);

    /**
     * @type {string} displayCategoryList
     * @name displayCategoryList
     * @description 카테고리 리스트 순서를 > 로 구분하여 표시
     */
    const displayCategoryList = useMemo(() => {
        let resultString = "";
        const arr = value;
        arr.forEach((item, idx) => {
            resultString += item;
            if (idx !== value.length - 1) {
                resultString += " > ";
            }
        });
        return resultString;
    }, [value]);

    // 팝업 노출 여부
    const [popupVisible, setPopupVisible] = React.useState<boolean>(false);

    /**
     * @function handleCheckBoxChange
     * @description 체크박스 클릭 시 active 값 변경
     */
    const handleCheckBoxChange = () => {
        actions.setControlValue("custom_sort_active", !active);
        //  actions.setControlValue("topN", undefined);
    };

    useEffect(() => {
        if (viz_type?.includes("area")) {
            if (actions) {
                if (JSON.stringify(value) !== JSON.stringify(saveList)) {
                    actions.setControlValue("custom_sort", value);
                }
                setSaveList(value);
            }
        }
    }, [value, viz_type]);

    return (
        <div>
            <ControlHeader
                name={props.name}
                label={t("Custom Sort")}
                description={props.description}
                validationErrors={props.validationErrors}
                renderTrigger
                rightNode={props.rightNode}
                leftNode={props.leftNode}
                onClick={props.onClick}
                hovered={props.hovered}
                tooltipOnClick={props.tooltipOnClick}
                danger={props.danger}
                warning={props.warning}
            />
            {useActive !== false && (
                <Container style={{ marginTop: "6px", marginBottom: "6px" }}>
                    <Checkbox id="custom-sort" checked={active} onChange={handleCheckBoxChange} />
                    <label htmlFor="custom-sort">{t("Custom Sort Active")}</label>
                </Container>
            )}

            <Container style={{ display: active ? "block" : "none" }}>
                <Container>
                    <Popover
                        title="Custom Sort"
                        visible={popupVisible}
                        trigger="click"
                        placement="right"
                        content={() => (
                            <PopoverContent
                                categoryList={value}
                                popupVisible={popupVisible}
                                handleApply={(currentList) => {
                                    actions.setControlValue("custom_sort", currentList);
                                    setPopupVisible(false);
                                }}
                                handleCancel={() => setPopupVisible(false)}
                            />
                        )}
                    >
                        <CustomButton onClick={() => setPopupVisible(true)}>
                            {t("Custom Sort")} <IconButton className="fa fa-caret-right" gridUnit={gridUnit} />
                        </CustomButton>
                    </Popover>
                </Container>
                <CategoryListBox color={colors.grayscale.light2}>{displayCategoryList}</CategoryListBox>
            </Container>
        </div>
    );
};

// eslint-disable-next-line theme-colors/no-literal-colors
const CategoryListBox = styled.div<{ color: string }>`
    padding: 4px 9px;
    //height: 32px;
    display: flex;
    align-items: center;
`;
const IconButton = styled.i<{ gridUnit: number }>`
    position: absolute;
    right: ${(props) => `${3 * props.gridUnit}px`};
    top: ${(props) => `${2 * props.gridUnit}px`};
`;

const CustomButton = styled(Button)`
    width: 100%;
    position: relative;
`;

const Container = styled.div`
    width: 100%;
    margin-bottom: 8px;
    // border: 1px solid ${(props) => props.color};
    // border-radius: 4px;
    label {
        margin-left: 8px;
    }
`;

export default CustomSortControl;
